<template>
	<div class="detail">
		<div class="page-container">
			<div class="header">
				<h2 class="title">数据详情</h2>
			</div>

			<el-config-provider :locale="zhCn">
				<el-descriptions :border="true" :column="1" class="detail-descriptions" v-if="detailData.id">
					<el-descriptions-item label="ID">{{ detailData.id }}</el-descriptions-item>
					<el-descriptions-item label="渠道ID">{{ detailData.channelId }}</el-descriptions-item>
					<el-descriptions-item label="安卓标识">{{ detailData.oaid }}</el-descriptions-item>
					<el-descriptions-item label="苹果标识">{{ detailData.idfa }}</el-descriptions-item>
					<el-descriptions-item label="是否回传">{{ detailData.isCallbackVal }}</el-descriptions-item>
					<el-descriptions-item label="回传时间">{{ detailData.callbackTime }}</el-descriptions-item>
					<el-descriptions-item label="广告主ID">{{ detailData.advertiserid }}</el-descriptions-item>
					<el-descriptions-item label="广告计划ID">{{ detailData.aid }}</el-descriptions-item>
					<el-descriptions-item label="广告创意ID">{{ detailData.cid }}</el-descriptions-item>
					<el-descriptions-item label="激活时间">{{ detailData.actionTime }}</el-descriptions-item>
					<el-descriptions-item label="安卓ID">{{ detailData.androidId }}</el-descriptions-item>
					<el-descriptions-item label="安卓ID（Md5加密）">{{ detailData.androidIdMd5 }}</el-descriptions-item>
					<el-descriptions-item label="转化行为">{{ detailData.behavior }}</el-descriptions-item>
					<el-descriptions-item label="归因url">{{ detailData.callbackUrl }}</el-descriptions-item>
					<el-descriptions-item label="目标页地址">{{ detailData.extraParam }}</el-descriptions-item>
					<el-descriptions-item label="IDFA_MD5">{{ detailData.idfaMd5 }}</el-descriptions-item>
					<el-descriptions-item label="IMEI_MD5">{{ detailData.imeiMd5 }}</el-descriptions-item>
					<el-descriptions-item label="IP地址">{{ detailData.ip }}</el-descriptions-item>
					<el-descriptions-item label="MAC_MD5">{{ detailData.macMd5 }}</el-descriptions-item>
					<el-descriptions-item label="OAID_MD5">{{ detailData.oaidMd5 }}</el-descriptions-item>
					<el-descriptions-item label="系统类型">{{ detailData.osVal }}</el-descriptions-item>
					<el-descriptions-item label="ua">{{ detailData.ua }}</el-descriptions-item>
					<el-descriptions-item label="快手归因值">{{ detailData.callback }}</el-descriptions-item>
					<el-descriptions-item label="苹果设备唯一标识">{{ detailData.caid }}</el-descriptions-item>
					<el-descriptions-item label="苹果设备唯一标识（Md5加密）">{{ detailData.caidMd5 }}</el-descriptions-item>
					<el-descriptions-item label="广告组ID">{{ detailData.campaignid }}</el-descriptions-item>
					<el-descriptions-item label="微信触点ID">{{ detailData.openid }}</el-descriptions-item>
					<el-descriptions-item label="监测时间">{{ detailData.monitorTime }}</el-descriptions-item>
					<el-descriptions-item label="上报时间">{{ detailData.reportTime }}</el-descriptions-item>
					<el-descriptions-item label="用户类型">{{ detailData.targetUserName }}</el-descriptions-item>
					<el-descriptions-item label="手机号">{{ detailData.mobile }}</el-descriptions-item>
					<el-descriptions-item label="登录时间">{{ detailData.loginTime }}</el-descriptions-item>
					<el-descriptions-item label="省份编码">{{ detailData.provinceCode }}</el-descriptions-item>
					<el-descriptions-item label="备用字段">{{ detailData.backup }}</el-descriptions-item>
					<el-descriptions-item label="更新时间戳">{{ detailData.updateTimestamp }}</el-descriptions-item>
					<el-descriptions-item label="是否自我接口测试">{{ detailData.sysCreateFrom }}</el-descriptions-item>
					<el-descriptions-item label="创建时间">{{ detailData.createTime }}</el-descriptions-item>
					<el-descriptions-item label="更新时间">{{ detailData.updateTime }}</el-descriptions-item>
				</el-descriptions>
			</el-config-provider>
		</div>
	</div>
</template>

<script>
import axios from '@/axios/create';
import { defineComponent } from 'vue';
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { ElButton, ElDescriptions, ElDescriptionsItem, ElMessage } from 'element-plus';

export default defineComponent({
	name: 'detail',
	components: {
		ElButton,
		ElDescriptions,
		ElDescriptionsItem
	},
	data() {
		return {
			zhCn,
			detailData: {}
		}
	},
	computed: {},
	mounted() {
		this.getDetail();
	},
	created() { },
	watch: {},
	methods: {
		getDetail() {
			const id = this.$route.query.id;
			if (!id) {
				ElMessage.error('缺少参数');
				return;
			}
			axios.get('/baiheKs/getBaiheKsById', { id }).then((res) => {
				console.log(res.data);
				if (res.code === 200) {
					const data = res.data || {};
					if (data.os == 0) {
						data.osVal = "安卓";
					} else if (data.os == 1) {
						data.osVal = "iOS";
					} else {
						data.osVal = "鸿蒙";
					}

					if (data.isCallback == 0) {
						data.isCallbackVal = "未回传";
					} else if (data.isCallback == 1) {
						data.isCallbackVal = "已回传";
					}

					 data.createTime = this.formatTime(data.createTime);
					 data.updateTime = this.formatTime(data.updateTime);
					 data.callbackTime = this.formatTime(data.callbackTime);
					 data.monitorTime = this.formatTime(data.monitorTime);
					 data.reportTime = this.formatTime(data.reportTime);
					 data.loginTime = this.formatTime(data.loginTime);

					this.detailData = data;
				} else {
					ElMessage.error(res.message || '获取详情失败');
				}
			}).catch(() => {
				ElMessage.error('获取详情失败');
			});
		},
		formatTime(time, format = "yyyy-MM-dd HH:mm:ss") {
            const date = time instanceof Date ? time : new Date(time);
            if (isNaN(date.getTime())) return "";

            const o = {
                "M+": date.getMonth() + 1,
                "d+": date.getDate(),
                "H+": date.getHours(),
                "m+": date.getMinutes(),
                "s+": date.getSeconds(),
                "S+": date.getMilliseconds()
            };

            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }

            for (let k in o) {
                if (new RegExp(`(${k})`).test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
                }
            }
            return format;
        }
	},
});
</script>

<style lang="scss" scoped>
.detail {
	min-height: 100vh;
	max-height: 100vh;
	background-color: #f5f7fa;
	padding: 20px;

	.page-container {
		min-height: calc(100vh - 40px);
		max-height: calc(100vh - 40px);
		margin: 0;
		background-color: #fff;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		padding: 24px;
		overflow-y: auto;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		.header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			.title {
				font-size: 20px;
				font-weight: 600;
				color: #1f2937;
				margin: 0;
				white-space: nowrap;
			}
		}

		.detail-descriptions {
			margin-top: 20px;

			:deep(.is-bordered-label) {
				font-weight: 600;
				color: #606266;
				background-color: #f5f7fa;
				width: 300px;
				white-space: nowrap;
			}

			:deep(.el-descriptions__body) {
				color: #303133;
			}
		}
	}
}
</style>
